<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Shifter</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Mark Wildyr</p>
<p class="P_Normal"> </p>
<p class="P_Normal">When Gray Fox sets out by canoe to visit Elk Horn, his childhood friend and secret crush, mysterious forces strand him on a terrifying hunk of ebony rock known as Black Island. During the dark, cold night, a strangely androgynous being seduces the young virgin. In the midst of his passion, the creature shifts into a comely youth, shocking the naïve young man. He can hardly wait to tell Elk Horn about the experience. But does he dare?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?57466e86